import {
	Button,
	ButtonSize,
	ColourStateSolid,
	DropdownMenu,
	DropdownMenuEntry,
	useLayout,
} from '@ukpostbox/frontend-framework';
import { faDoorOpen } from '@fortawesome/pro-solid-svg-icons/faDoorOpen';
import { faRectangleHistory } from '@fortawesome/pro-solid-svg-icons/faRectangleHistory';
import React from 'react';
import { NavLink, useNavigate, useParams } from 'react-router';
import { useAccountUser } from '@ukpostbox/client-data';
import { useAuthorisedUser } from '../../../_Auth/Providers/AuthProvider';
import { Logo } from '../../../_Global/Components/Logo';

function UserPageHeader() {
	const navigate = useNavigate();
	const { pageId } = useParams();
	const { data } = useAccountUser();
	const { isTiny, isSmall, isMedium, isLarge, isXL } = useLayout();

	const { LogOut } = useAuthorisedUser();

	return (
		<div className={`row ${isTiny || isSmall ? 'p-sm' : ''} ${isXL ? 'mt-sm mb-lg' : ''} raised-header`}>
			<div className='col-xs-12 col-center-md-8 col-center-lg-10 col-center-xxl-8'>
				<div className='row'>
					{!isTiny && !isSmall && !isMedium && <div className='col-xs-12 col-md-3 col-xl-3' />}
					<div className='col-xs-12 col-lg-9 col-xl-6'>
						<div className={`row ${isMedium ? 'mt-md' : ''}`}>
							<div className='col-xs-6'>
								<NavLink to={`/sends-page/${pageId}`}>
									<Logo />
								</NavLink>
							</div>
							<div className='col-xs-6 text-right'>
								<DropdownMenu
									title='Sends Page User'
									trigger={
										<Button
											title={data?.name as string}
											colour={ColourStateSolid.Text}
											size={ButtonSize.Small}
											showArrow
										/>
									}
								>
									<DropdownMenuEntry
										title='History'
										onClick={() => navigate('../sends-page/history')}
										icon={faRectangleHistory}
									/>
									{!data?.roles.includes('SENDS_PAGE_ADMIN') && !data?.roles.includes('MANAGER') && (
										<>
											<DropdownMenuEntry title='Divider' sectionDivider />
											<DropdownMenuEntry
												title='Logout'
												onClick={() => LogOut()}
												icon={faDoorOpen}
											/>
										</>
									)}
								</DropdownMenu>
							</div>
						</div>
					</div>
					{!isTiny && !isSmall && !isMedium && !isLarge && <div className='col-md-3' />}
				</div>
			</div>
		</div>
	);
}

export default UserPageHeader;
